// eslint-disable-next-line import/prefer-default-export
export const WIDTH_ENUM = {
    values: ['small', 'medium', 'large', 'x-large'],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968,
    },
    defaultValue: 'medium',
};
export const gutter = 60;
//# sourceMappingURL=shared-variables.js.map